import React from 'react';

import {fetchConnections} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadConnections = ({children}) => {
    useStoredDataChanged();
    return <Loader promises={[fetchConnections()]}>{children}</Loader>;
};

export default LoadConnections;
